import { axiosGet, axiosPost } from "../axios/config";

const backendAPI = import.meta.env.VITE_REACT_APP_API_URL;

export const login = (data) => {
	const params = new URLSearchParams(window.location.search);
	const tenantToken = params.get("tenant_invitation_token");
	if (tenantToken) {
		data.tenant_invitation_token = tenantToken;
	}
	return axiosPost(backendAPI + "/api/v1/login", data);
};

export const ResetPasswordMail = (data) => {
	return axiosPost(backendAPI + "/api/v1/reset-password-mail", data);
};

export const confirmResetPassword = (data) => {
	return axiosPost(backendAPI + "/api/v1/reset-password", data);
};

/** Returns the current authorized user */
export const getUser = () => {
	return axiosGet(backendAPI + "/api/v1/user");
};
export const getadmin = (data) => {
	return axiosPost(backendAPI + "/api/v1/get-super-admins", data);
};
export const getadminLogo = () => {
	return axiosGet(backendAPI + "/api/v1/get-admin-brandlogo");
};
export const sendIvite = (data) => {
	return axiosPost(backendAPI + "/api/v1/send-invite", data);
};
export const verifyLink = (data) => {
	return axiosPost(backendAPI + "/api/v1/verify-token", data);
};
export const addSignupUser = (data) => {
	return axiosPost(backendAPI + "/api/v1/add-invited-member", data);
};
export const getInvitedUser = (data) => {
	return axiosPost(backendAPI + "/api/v1/get-all-invitations", data);
};
export const getCompanies = (data) => {
	return axiosPost(backendAPI + "/api/v1/companies", data);
};
export const getOrganizations = (data) => {
	return axiosPost(backendAPI + "/api/v2/administration/organizations", data);
};

// Sends the Cognito authorization code to Laravel.
// Laravel exchanges it with Cognito for tokens and returns
// the same {token, user} shape as the normal login endpoint.
export const exchangeCognitoCode = (code) => {
	return axiosPost(backendAPI + "/api/v1/auth/cognito/callback", { code });
};
